import { SVGProps, Ref, forwardRef } from 'react';

export const HumanCircleFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 1c8.25 0 11 5.5 11 11s-2.75 11-11 11S1 17.5 1 12 3.75 1 12 1m-5 9.1a.9.9 0 0 0 0 1.8h3.246l-1.13 5.932a.9.9 0 0 0 1.768.336L11.487 15h1.026l.603 3.168a.9.9 0 0 0 1.768-.336l-1.13-5.932H17a.9.9 0 0 0 0-1.8zM12 5c-1.5 0-2 1-2 2s.5 2 2 2 2-1 2-2-.5-2-2-2"
                fill="currentColor"
            />
        </g>
    </svg>
));
HumanCircleFilledSize24Glyph.displayName = 'HumanCircleFilledSize24Glyph';
